var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.31 10.808l3.768-4.32H.646V5.096h15.408L12.31.8h1.608l4.44 4.992-4.44 5.016H12.31z",
    fill: "currentColor"
  })));
}

var MemoSvgArrowSmall = /*#__PURE__*/React.memo(SvgArrowSmall);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTkgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMi4zMDk5IDEwLjgwOEwxNi4wNzc5IDYuNDg4SDAuNjQ1ODc1VjUuMDk2SDE2LjA1MzlMMTIuMzA5OSAwLjhIMTMuOTE3OUwxOC4zNTc5IDUuNzkyTDEzLjkxNzkgMTAuODA4SDEyLjMwOTlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { MemoSvgArrowSmall as ReactComponent };